import { render, staticRenderFns } from "./ApiList.vue?vue&type=template&id=cb1a1d24"
import script from "./ApiList.vue?vue&type=script&lang=js"
export * from "./ApiList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports